// login token duration
export const JWT_DURATION = '1h'
